import { useCallback, useRef } from "react"

import { toServerErrors } from "../components/JiraTemplateModal/helpers"

import type { ServerFieldError } from "./useTemplateTest.types"

// Errors a vendor reported for a template stay on their fields until the value changes
export const useServerFieldErrors = (
  initialErrors: Record<string, ServerFieldError> = {}
) => {
  const serverErrors = useRef(initialErrors)

  const setServerErrors = (
    fieldErrors: Record<string, string>,
    referenceValues: Record<string, unknown>
  ) => {
    serverErrors.current = {
      ...serverErrors.current,
      ...toServerErrors(fieldErrors, referenceValues)
    }
  }

  const createServerErrorRule = (fieldName: string) => ({
    validator: (_: unknown, value: unknown) => {
      const error = serverErrors.current[fieldName]

      if (!error) return Promise.resolve()
      if (value !== error.value) {
        delete serverErrors.current[fieldName]
        return Promise.resolve()
      }

      return Promise.reject(new Error(error.message))
    }
  })

  const getServerErrorFields = useCallback(
    () => Object.keys(serverErrors.current),
    []
  )

  return { setServerErrors, createServerErrorRule, getServerErrorFields }
}
